import { firestore } from "../firebase.js";

const state = {
    buzon: null,
};

//
const mutations = {

    enviarABuzon(state, buzon) {
        state.buzon = buzon;
    },
};

const actions = {

    async Buzon({ commit }, { typeMessage, mensaje }) {

        let buzon = await firestore.collection("sugerencia_y_errores").add({
            typeMessage: typeMessage,
            mensaje: mensaje,
            fecha: new Date(),
        });
        commit("enviarABuzon", buzon);
    },
};
const getters = {};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};